window['ThemeSection_header'] = (count) => {
  const dropdownCount = parseInt(count);
  const menuOpen = {};
  for (let i = 0; i < dropdownCount; i++) {
    menuOpen['menu' + i] = false;
  }

  return {
    menuOpen: menuOpen,
    searchOpen: false,
    headerIsSticky: false,
    scrollY: 0,
    navWrapped: false,
    headerHeight: 0,
    get isStuck() {
      return this.headerIsSticky && this.scrollY > this.headerHeight * 2;
    },
    get menuIsActive() {
      return !Object.keys(menuOpen).every((k) => !menuOpen[k]);
    },
    mounted() {
      initTeleport(this.$root);

      // ✅ Init header locale/country selectors (data-disclosure-*)
      this.initHeaderLocalizationDisclosures();

      Alpine.store('modals').register('nav', 'leftDrawer');

      document.addEventListener('keyup', (event) => {
        if (event.key === 'Escape') {
          if (this.searchOpen === false) {
            for (let i = 0; i < dropdownCount; i++) {
              if (this.menuOpen['menu' + i] === true) {
                this.menuOpen['menu' + i] = false;
                document.querySelector(`[aria-controls="menu${i}"]`).focus();
              }
            }
          } else {
            if (!document.getElementById('predictiveSearchResults')) {
              document.body.dispatchEvent(
                new CustomEvent('shapes:search:closebutton')
              );
            }
          }
        }
      });

      document.body.addEventListener('shapes:search:closebutton', () => {
        this.searchOpen = false;

        this.$nextTick(() => {
          const searchToggleEl = this.$root.querySelector('[data-open-search]');

          if (searchToggleEl) {
            setTimeout(() => {
              searchToggleEl.focus();
            }, 300);
          }
        });
      });

      if (
        this.$root.hasAttribute('data-sticky-header') &&
        this.$root.hasAttribute(
          'data-transparent-when-overlay-enabled-and-stuck'
        )
      ) {
        this.setUpStickyDetection();
      }

      // set header height
      this.headerResizeFunctions();
      this._debouncedHeaderFunctions = debounce(
        this.headerResizeFunctions.bind(this),
        300
      );

      window.addEventListener('resize', this._debouncedHeaderFunctions);
      document.addEventListener('shopify:section:load', (e) => {
        if (!e.target.querySelector('.site-header')) return;
        this.headerResizeFunctions();
      });
    },

    headerResizeFunctions() {
      this.calculateHeaderHeight();
      this.calculateNavWrap();
    },

    setUpStickyDetection() {
      const headerContainerEl = this.$root.closest('.shopify-section');

      const sentinelEl = document.createElement('div');
      sentinelEl.setAttribute('id', 'HeaderSentinel');

      headerContainerEl.parentNode.insertBefore(sentinelEl, headerContainerEl);

      const observer = new IntersectionObserver(
        (e) => {
          e.forEach((entry) => {
            this.headerIsSticky = entry.intersectionRatio < 1 ? true : false;
          });
        },
        {
          rootMargin: '-1px 0px 0px 0px',
          threshold: [1],
        }
      );

      observer.observe(sentinelEl);

      let timer = null;

      const checkScrollPosition = (e) => {
        this.scrollY = window.scrollY;
        if (timer !== null) {
          clearTimeout(timer);
        }
        timer = setTimeout(() => {
          this.scrollY = window.scrollY;
        }, 150);
      };

      const _throttledScrollHandler = throttle(checkScrollPosition, 150);
      document.addEventListener('scroll', _throttledScrollHandler);

      this.scrollY = window.scrollY;
    },

    calculateNavWrap() {
      const wrappedItems = [];
      let prevItem = {};
      let currItem = {};
      if (this.$refs.navigation !== undefined) {
        const items = this.$refs.navigation.children;
        for (var i = 0; i < items.length; i++) {
          currItem = items[i].getBoundingClientRect();
          if (prevItem && prevItem.top < currItem.top) {
            wrappedItems.push(items[i]);
          }
          prevItem = currItem;
        }
        if (wrappedItems.length > 0) {
          this.navWrapped = true;
        } else {
          this.navWrapped = false;
        }
      }
    },

    calculateHeaderHeight() {
      this.headerHeight =
        document.getElementById('headerBorderWrap').clientHeight;
      document.documentElement.style.setProperty(
        '--header-height',
        `${this.headerHeight}px`
      );
    },

    openMenu(index) {
      this.menuOpen['menu' + index] = true;
    },

    focusOut(event, menu) {
      if (event.relatedTarget) {
        const dropdownParent = event.relatedTarget.closest(
          '[data-header-dropdown]'
        );
        if (!dropdownParent) {
          this.menuOpen[menu] = false;
        }
      }
    },

    searchFocusOut() {
      this.$nextTick(() => {
        if (!this.$refs.searchFieldComponent.contains(document.activeElement))
          this.searchOpen = false;
      });
    },

    closeSearch() {
      this.searchOpen = false;
      this.$refs.search.focus();
    },

    openSearch() {
      this.searchOpen = true;
      let input = document.querySelector('.header-search-input');
      setTimeout(() => {
        input.focus();
      }, 100);
    },

    // ---------------------------
    // ✅ Localization disclosures
    // ---------------------------
    initHeaderLocalizationDisclosures() {
      const roots = this.$root.querySelectorAll(
        '[data-disclosure-country], [data-disclosure-locale]'
      );

      if (!roots || roots.length === 0) return;

      roots.forEach((root) => this._initSingleDisclosure(root));

      // Close on outside click
      document.addEventListener('click', (e) => {
        roots.forEach((root) => {
          if (!root.contains(e.target)) this._closeDisclosure(root);
        });
      });

      // Close on ESC (note: you also have an ESC handler; this is harmless)
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          roots.forEach((root) => this._closeDisclosure(root));
        }
      });
    },

    _initSingleDisclosure(root) {
      const toggle = root.querySelector('[data-disclosure-toggle]');
      const list = root.querySelector('[data-disclosure-list]');
      const input = root.querySelector('[data-disclosure-input]');
      const form = root.closest('form');

      if (!toggle || !list || !input || !form) return;

      // Initial state
      toggle.setAttribute('aria-expanded', 'false');
      list.setAttribute('inert', '');

      toggle.addEventListener('click', (e) => {
        e.preventDefault();

        const isOpen = toggle.getAttribute('aria-expanded') === 'true';

        // Close other open disclosure lists within this header
        this.$root
          .querySelectorAll('[data-disclosure-list].is-open')
          .forEach((otherList) => {
            if (otherList !== list) {
              otherList.classList.remove('is-open');
              otherList.setAttribute('inert', '');
              const otherToggle =
                otherList.parentElement?.querySelector('[data-disclosure-toggle]');
              if (otherToggle) otherToggle.setAttribute('aria-expanded', 'false');
            }
          });

        if (isOpen) {
          this._closeDisclosure(root);
        } else {
          this._openDisclosure(root);
        }
      });

      // Pick option: set hidden input + submit
      root.querySelectorAll('[data-disclosure-option]').forEach((opt) => {
        opt.addEventListener('click', (e) => {
          e.preventDefault();
          const value = opt.getAttribute('data-value');
          if (!value) return;

          input.value = value;
          this._closeDisclosure(root);
          form.submit();
        });
      });
    },

    _openDisclosure(root) {
      const toggle = root.querySelector('[data-disclosure-toggle]');
      const list = root.querySelector('[data-disclosure-list]');
      if (!toggle || !list) return;

      toggle.setAttribute('aria-expanded', 'true');
      list.removeAttribute('inert');
      list.classList.add('is-open');
    },

    _closeDisclosure(root) {
      const toggle = root.querySelector('[data-disclosure-toggle]');
      const list = root.querySelector('[data-disclosure-list]');
      if (!toggle || !list) return;

      toggle.setAttribute('aria-expanded', 'false');
      list.setAttribute('inert', '');
      list.classList.remove('is-open');
    },
  };
};
